import { Flex, Skeleton } from '@iheartjane/reefer';

import styles from './rowHeaderSkeleton.module.css';

interface RowHeaderSkeleton {
  productCountVisible?: boolean;
}

export function RowHeaderSkeleton({
  productCountVisible = true,
}: RowHeaderSkeleton) {
  return (
    <Skeleton animate className={styles['rowHeader']}>
      <Flex
        alignItems="center"
        flexDirection="row"
        justifyContent="space-between"
      >
        <div>
          <Skeleton.Bone className={styles['header']} />
          {productCountVisible && (
            <Skeleton.Bone className={styles['productCount']} />
          )}
        </div>
        <Skeleton.Bone className={styles['viewAll']} />
      </Flex>
    </Skeleton>
  );
}
